// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__eDHtE","author":"Table_author__1xrtA","authorImage":"Table_authorImage__2gSPG","unreadRow":"Table_unreadRow__2mQEs"};